<div
	class="flex items-center h-12 gap-4 border-b"
	[ngClass]="{
    'border-system-red' : type === 'error',
    'border-system-green' : type === 'success',
  }">
	<app-svg-icon *ngIf="type === 'success'" class="text-system-green" width="20" height="20" [iconName]="'check-circle.svg'" [iconId]="'check-circle'"></app-svg-icon>
	<app-svg-icon *ngIf="type === 'error'" class="text-system-red" width="20" height="20" [iconName]="'alert.svg'" [iconId]="'alert'"></app-svg-icon>
	<p
		[ngClass]="{
        'text-system-red' : type === 'error',
        'text-system-green' : type === 'success',
      }">
		{{ message }}
	</p>
</div>
